// extracted by mini-css-extract-plugin
export default {"page":"Page_page__Rwm9R3DC","title":"Page_title__plbvPibK"};